import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

type Hue = 'blue' | 'violet' | 'fuchsia' | 'pink' | 'red' | 'orange' | 'teal' | 'green' | 'sky';
const HUES: Hue[] = ['blue', 'violet', 'fuchsia', 'pink', 'red', 'orange', 'teal', 'green', 'sky'];

export type CursorColor = { pointer: string; label: string };

// FNV-1a: cheap, and spreads short ids across the hues well.
function hash(value: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < value.length; i++) {
    h ^= value.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/**
 * A color per browser tab, computed from the tab's id so every viewer agrees on it and it stays
 * put across reloads. Two tabs of one person get their own colors. The arrow uses the 600 shade;
 * labels use 700, which keeps white text above 4.5:1.
 */
export function colorForTab(tab: string): CursorColor {
  const hue = HUES[hash(tab) % HUES.length] ?? 'blue';
  return { pointer: themeVars.palette[`${hue}-600`], label: themeVars.palette[`${hue}-700`] };
}
